import { Dialog, DialogContentHeadless } from 'v5/design-system/Dialog';
import { MountElementProps } from 'v5/messages/mount-element';
import { UnsavedChangesProtection } from 'v5/patterns/forms/unsaved-changes/UnsavedChangesProtection';
import {
  ReportTemplateEditorDialogContent,
  type ReportTemplateEditorDialogContentProps
} from './ReportTemplateEditorDialogContent';

export type ReportTemplateEditorDialogProps = MountElementProps &
  Omit<ReportTemplateEditorDialogContentProps, 'open' | 'close'>;

/** The report template editor in a dialog that asks before unsaved changes are dropped. */
export function ReportTemplateEditorDialog({
  open,
  onOpenChange,
  close,
  ...contentProps
}: ReportTemplateEditorDialogProps) {
  return (
    <UnsavedChangesProtection open={open} onOpenChange={onOpenChange}>
      {dialogProps => (
        <Dialog {...dialogProps}>
          <DialogContentHeadless className="max-w-180">
            <ReportTemplateEditorDialogContent
              open={dialogProps.open}
              close={close}
              {...contentProps}
            />
          </DialogContentHeadless>
        </Dialog>
      )}
    </UnsavedChangesProtection>
  );
}
